<script setup lang="ts">
// Moved font awesome imports from nuxt.config.ts to here
// to avoid loading them on landing pages. They will be replaced
// with UIIcon component in the future.
import '@fortawesome/fontawesome-svg-core/styles.css'
import '/public/fontawesome/css/all.min.css'

import { useMiscResizeStore } from '~/stores/miscResize'

const { SETUP_EVENT_LISTENERS, COMPUTE_AND_SET_SCREEN_SIZE } =
  useMiscResizeStore()

onMounted(() => {
  COMPUTE_AND_SET_SCREEN_SIZE()
  SETUP_EVENT_LISTENERS()
})
</script>

<template>
  <div class="layoutWrapper barren">
    <slot />
  </div>
</template>
